const reducer = (state, action) => ({
  ...state,
  selectedDate: action.date,
  carouselStartPosition: action.carouselStartPosition,
});

export default reducer;
